import * as yup from "yup";

export const editProfessionalSchema = yup.object().shape({
  email: yup
    .string()
    .required("E-mail é obrigatório")
    .email("E-mail inválido."),
  crfa: yup
    .string()
    .trim()
    .required("O Número de Conselho de Classe é obrigatório."),
});
